export const API_KEY = 'AIzaSyAeXz3bqi6Ti1QU-X80BzbRjRrQKwB7aRA';

export default API_KEY;